<script setup lang="ts">
import {
  RelatieAdresField,
  RelatieBedrijfsnaamField,
  RelatieEmailField,
  RelatieFinancieelEmailadresField,
  RelatieKvkField,
  RelatieRechtsvormField,
  RelatieRekeningField,
  RelatieSbiCodeField,
  RelatieTelefoonField,
  RelatieWebsiteField,
} from '@relatie-lib/relatieGegevens/relatiegegevensForm/fields';
import { isReadonlyInjectionKey } from '@relatie-lib/relatieGegevens/relatiegegevensForm/keys';
import { sbiCodeLookupDetailsFn } from '@relatie-lib/relatieGegevens/services/sbiLookup';
import FieldGroup from '@shared/form/FieldRowV2/FieldGroup.vue';
import { computed, provide } from 'vue';
import FormLayout from './FormLayout.vue';
import RelatieBedrijfseigenaarField from './RelatieBedrijfseigenaarField.vue';

const props = defineProps<{
  relatienummer?: number;
  isSubmitting: boolean;
  loading: boolean;
  toonBedrijfseigenaar: boolean;
  kanOpslaan?: boolean;
  kanBewerken?: boolean;
  saveButtonText?: string;
}>();

const emit = defineEmits<{ save: [] }>();

const isInEditMode = defineModel<boolean>('modelValue');

const isReadonly = computed(() => !isInEditMode.value);

provide(isReadonlyInjectionKey, { value: isReadonly });
</script>

<template>
  <FormLayout
    :loading
    :is-submitting
    :kan-opslaan="props.kanOpslaan"
    :kan-bewerken="props.kanBewerken"
    @save="emit('save')"
    title="Bedrijf"
    v-model="isInEditMode"
    :save-button-text="props.saveButtonText"
  >
    <FieldGroup :class="{ 'gap-0!': !isInEditMode }">
      <slot></slot>
      <RelatieKvkField />
      <RelatieBedrijfsnaamField />
      <RelatieBedrijfseigenaarField v-if="toonBedrijfseigenaar" />
      <RelatieAdresField />
      <RelatieRechtsvormField />
      <RelatieSbiCodeField
        :lookup-details-fn="(sbiCode: string) => sbiCodeLookupDetailsFn(sbiCode)"
      />
      <RelatieRekeningField id="relatiegegevens-relatie-iban" />
      <RelatieTelefoonField />
      <RelatieEmailField />
      <RelatieFinancieelEmailadresField />
      <RelatieWebsiteField />
    </FieldGroup>
  </FormLayout>
</template>
